import { combineReducers } from '@reduxjs/toolkit'
import { connectRouter } from 'connected-react-router'
import { History } from 'history'
import { globalLoading } from '@ocean/api'
import customerSpecificCategories from 'core/customerSpecificCategories/slices/customerSpecificCategories'
import dictionaries from 'core/dictionaries/slices/dictionaries'
import environment from 'core/environment/slices/environment'
import people from 'core/people/slices/people'
import session from 'core/session/slices/session'
import staIntegration from 'core/staIntegration/slices/staIntegration'
import staLegacyPlayer from 'core/staIntegration/slices/staLegacyPlayer'
import system from 'core/system/slices/system'
import userDeclaration from 'core/userDeclaration/slices/userDeclaration'
import auth from 'modules/Auth/slices/auth'
import home from 'modules/Home/slices/home'
import notifications from 'modules/Notifications/slices/notifications'
import onboarding from 'modules/Onboarding/slices/onboarding'
import profile from 'modules/Profile/slices/profile'
import search from 'modules/Search/slices/search'
import sso from 'modules/Sso/slices/sso'
import aproDetails from 'modules/activityDetails/AproDetails/slices/aproDetails'
import certificateDetails from 'modules/activityDetails/CertificateDetails/slices/certificateDetails'
import cesCstDetails from 'modules/activityDetails/CesCstDetails/slices/cesCstDetails'
import cesDetailedDetails from 'modules/activityDetails/CesDetailedDetails/slices/cesDetailedDetails'
import cesStcwDetails from 'modules/activityDetails/CesStcwDetails/slices/cesStcwDetails'
import companyNoticeDetails from 'modules/activityDetails/CompanyNoticeDetails/slices/companyNoticeDetails'
import companySpecificTrainingDetails from 'modules/activityDetails/CompanySpecificTrainingDetails/slices/companySpecificTrainingDetails'
import courseDetails from 'modules/activityDetails/CourseDetails/slices/courseDetails'
import distanceCourseDetails from 'modules/activityDetails/DistanceCourseDetails/slices/distanceCourseDetails'
import educationDetails from 'modules/activityDetails/EducationDetails/slices/educationDetails'
import elearningDetails from 'modules/activityDetails/ElearningDetails/slices/elearningDetails'
import marlinsEnglishTestDetails from 'modules/activityDetails/MarlinsEnglishTestDetails/slices/marlinsEnglishTestDetails'
import onboardAssessmentDetails from 'modules/activityDetails/OnboardAssessmentDetails/slices/onboardAssessmentDetails'
import pproDetails from 'modules/activityDetails/PproDetails/slices/pproDetails'
import rapidElearningDetails from 'modules/activityDetails/RapidElearningDetails/slices/rapidElearningDetails'
import selfAssessmentDetails from 'modules/activityDetails/SelfAssessmentDetails/slices/selfAssessmentDetails'
import serviceRecordDetails from 'modules/activityDetails/ServiceRecordDetails/slices/serviceRecordDetails'
import surveyDetails from 'modules/activityDetails/SurveyDetails/slices/surveyDetails'
import activityLogSlices from 'modules/activityLog/common/slices'
import mobileNativeRedirect from 'modules/redirects/MobileNativeRedirect/slices/mobileNativeRedirect'
import proxyRedirect from 'modules/redirects/ProxyRedirect/slices/proxyRedirect'
import staRedirect from 'modules/redirects/StaRedirect/slices/staRedirect'
import requirementsSlices from 'modules/requirements/common/slices'
import simulatorTrainingSlices from 'modules/simulatorTrainings/common/slices'
import distanceCourses from 'modules/trainingLibrary/DistanceCourses/slices/distanceCourses'
import elearning from 'modules/trainingLibrary/Elearning/slices/elearning'
import rapidElearning from 'modules/trainingLibrary/RapidElearning/slices/rapidElearning'
import surveys from 'modules/trainingLibrary/Surveys/slices/surveys'
import trainingLibrary from 'modules/trainingLibrary/TrainingLibrary/slices/trainingLibrary'
import virtualClassroomSlices from 'modules/virtualClassrooms/common/slices'

const createRootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    globalLoading,
    session,
    environment,
    system,
    people,
    auth,
    home,
    trainingLibrary,
    elearningDetails,
    onboarding,
    notifications,
    ...requirementsSlices,
    distanceCourseDetails,
    rapidElearningDetails,
    surveyDetails,
    onboardAssessmentDetails,
    selfAssessmentDetails,
    companySpecificTrainingDetails,
    certificateDetails,
    courseDetails,
    educationDetails,
    serviceRecordDetails,
    companyNoticeDetails,
    pproDetails,
    cesDetailedDetails,
    cesStcwDetails,
    cesCstDetails,
    marlinsEnglishTestDetails,
    aproDetails,
    search,
    surveys,
    rapidElearning,
    distanceCourses,
    elearning,
    dictionaries,
    staIntegration,
    staRedirect,
    proxyRedirect,
    sso,
    profile,
    staLegacyPlayer,
    mobileNativeRedirect,
    userDeclaration,
    customerSpecificCategories,
    ...simulatorTrainingSlices,
    ...virtualClassroomSlices,
    ...activityLogSlices,
  })

export default createRootReducer
